import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { cn } from "@/lib/utils";

const KEY = "prodtrack_atelier_son";
export const SEUIL_ALERTE_SEC = 300;

const beep = (ctx) => {
  const o = ctx.createOscillator(), g = ctx.createGain();
  o.type = "square"; o.frequency.value = 880;
  g.gain.setValueAtTime(0.0001, ctx.currentTime);
  g.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.35);
  o.connect(g).connect(ctx.destination); o.start(); o.stop(ctx.currentTime + 0.4);
};

/** Alarme sonore (WebAudio, sans fichier) + clignotement quand un arrêt non planifié dépasse le seuil. */
export const useAlarmeArret = (active) => {
  const [son, setSon] = useState(() => localStorage.getItem(KEY) !== "off");
  const ctxRef = useRef(null);
  useEffect(() => { localStorage.setItem(KEY, son ? "on" : "off"); }, [son]);
  useEffect(() => {
    if (!active || !son) return;
    const play = () => { try { ctxRef.current = ctxRef.current || new (window.AudioContext || window.webkitAudioContext)(); if (ctxRef.current.state === "suspended") ctxRef.current.resume(); beep(ctxRef.current); setTimeout(() => beep(ctxRef.current), 500); } catch { /* audio indisponible */ } };
    play();
    const t = setInterval(play, 5000);
    return () => clearInterval(t);
  }, [active, son]);
  return { son, setSon };
};

export const SonToggle = ({ son, setSon }) => (
  <button data-testid="alarme-son-toggle" onClick={() => setSon(!son)} title={son ? "Couper l'alarme sonore" : "Activer l'alarme sonore"}
    className={cn("h-8 px-2.5 border rounded-sm text-xs flex items-center gap-1.5", son ? "border-border hover:bg-muted" : "border-amber-500/50 text-amber-300 bg-amber-950/30")}>
    {son ? <Volume2 className="h-3.5 w-3.5" /> : <VolumeX className="h-3.5 w-3.5" />}{son ? "Son" : "Muet"}
  </button>
);
